import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";

export const Route = createFileRoute("/dashboard/inspections")({
  component: () => <Outlet />,
  beforeLoad: ({ context }) => {
    // Viewer floor — viewers get read-only access to the inspections list
    // and detail (matching the inspection-svc list/get viewer floor and the
    // sidebar nav). Create/planning actions are gated within the pages, and
    // the inspector-only execution routes (hac-form, paper-sheet) keep their
    // own inspector guards. This also keeps /dashboard/inspections reachable
    // for every authenticated role, since it's the redirect target that all
    // requireMinRole failures land on — an inspector floor here made that
    // redirect loop back onto itself.
    requireMinRole(context.session, "viewer");
  },
});
